import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: (p) => p.spacing(1),
};

export const header: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
};

export const labelWrapper: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: (p) => p.spacing(1),
};

export const row: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: (p) => p.spacing(1),
};

export const actionIcon: SxStyle = {
  cursor: 'pointer',
  color: (p) => p.palette.grey[600],
};

export const popoverTitle: SxStyle = {
  color: (p) => p.palette.common.black,
  fontWeight: (p) => p.typography.fontWeightSemiBold,
};
